export const filterCategories = [
    'colorName',
    'finish',
    'fragrance',
    'makeupProperties',
    'mkProductType',
    'productSeries',
    'seminarYear',
    'skinTone',
    'skinType',
    'usageRegion',
] as const;
